import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import constantMessage from "../constants/constantMsg.json";
import { isExpired } from "react-jwt";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
// import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import logoutIcon from "../assets/images/icons/log-out.svg";
import dashboardIcon from '../assets/images/header/icons/dashboard.svg';
// import usersIcon from '../assets/images/header/icons/users.svg';
// import helpcircleIcon from '../assets/images/header/icons/help-circle.svg';
import briefcaseIcon from '../assets/images/header/icons/briefcase.svg';
import settingIcon from '../assets/images/header/icons/settings.svg';
import reportIcon from '../assets/images/header/icons/reports.svg';
import zoneIcon from '../assets/images/header/icons/zone_icon.svg';
import reportIcon2 from '../assets/images/header/icons/reports2.svg';
import adminIcon from '../assets/images/header/icons/admin_icon.svg';
import partnersIcon from '../assets/images/header/icons/demand.svg';
import listbreadcrumbsIcon from '../assets/images/icons/list_breadcrumbs.svg';
import listIcon from '../assets/images/icons/list_icon.svg';
import AdTxt from '../assets/images/header/icons/adtxt.svg';
import HeaderArrow from '../assets/images/header/icons/header_droparrow.svg';
import compatibleImg from "../assets/images/compatible.svg";
import blackLogo from "../assets/logo/helix_black_logo_with_xapads.svg"
import whiteLogo from "../assets/logo/helix_white_logo_with_xapads.svg"


const Header = () => {
  const location = useLocation();
  const [loggedin, setLoggedin] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [checkRole, setCheckRole] = useState("admin");
  // const [heading, setHeading] = useState("");


  const logout = () => {
    notifysuccess(constantMessage.Logout_MSG);

    setTimeout(() => {
      Cookies.remove("token_xapads_ssp");
      window.location.replace("/login");
    }, 1000);
  };

  useEffect(() => {
    const tokenExpired = async () => {
      let status = Cookies.get("token_xapads_ssp") ? true : false;
      if (status) {
        let token = Cookies.get("token_xapads_ssp");
        const isMyTokenExpired = isExpired(token);
        if (isMyTokenExpired) {
          notifyfailure("Token Expired! Signing Out");
          setTimeout(() => {
            Cookies.remove("token_xapads_ssp");
            window.location.replace("/login");
          }, 1500);
        }
      }
    };

    const timeoutId = setTimeout(() => {
      tokenExpired();
      const intervalId = setInterval(tokenExpired, 15000); // Call every 15 sec
      return () => clearInterval(intervalId);
    }, 10000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const accountCheck = async () => {
      if (email !== "") {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          let token = Cookies.get("token_xapads_ssp");
          let emailToken = jwtDecode(token).email;
          if (emailToken !== email) {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      } else {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          window.location.reload();
        }
      }
    };

    const timeoutId = setTimeout(() => {
      const intervalId = setInterval(accountCheck, 3000); // CHECK IN  every 3sec
      return () => clearInterval(intervalId);
    }, 3000);
    return () => clearTimeout(timeoutId);
  });

  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    setLoggedin(status);

    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      if (token) {
        setEmail(jwtDecode(token)?.email);
        setName(jwtDecode(token)?.p_name)
        setCheckRole(jwtDecode(token)?.role);
      }
    }
  }, [location.pathname]);

  return (
    <>
      <ToastContainer />
      {loggedin && location.pathname === "/onboarding" && (
        <header className="v1">
          <div className="compatible_content">
            <img
              src={blackLogo}
              alt="USP" className="logo" />
            <img src={compatibleImg} alt="compatible" class="w_100" />
            <button className="logout_compatible" onClick={logout}>Logout</button>
          </div>
          <div className="container_box--header onboarding_logo_d2">
            <Row gutter={16} className="w_100 ">
              <Col span={12} className="container_box--logo">
                <img
                  src={blackLogo}
                  alt="USP" />
              </Col>

              <Col span={12} className='container_box--end pe-0'>
                <button className="logout_link" onClick={logout}><img src={logoutIcon} alt="USP" /> Logout </button>
              </Col>
            </Row>
          </div>
        </header>
      )}
      {loggedin && location.pathname !== "/onboarding" && (
        <header>
          <div className="compatible_content">
            <img
              src={blackLogo}
              alt="USP" className="logo" />
            <img src={compatibleImg} alt="compatible" class="w_100" />
            <button className="logout_compatible" onClick={logout}>Logout</button>
          </div>
          <div className="container_box--header">
            <Row gutter={16} className='w-100 p-0'>
              <Col span={20} className='container_box--logo'>
                <Link to="/dashboard" className='logo'><img

                  src={whiteLogo}
                  alt='USP' /></Link>
                <nav>
                  <ul>
                    <li><Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}><img src={dashboardIcon} alt='Dashboard' /> Dashboard</Link></li>

                    <li><Link to="/zoneList" className={location.pathname === "/zoneList" ? "active" : ""}><img src={zoneIcon} alt='Zone' /> Zone</Link></li>

                    {(checkRole === "sa" || checkRole === "mobops") && (<li><Link to="/publisherList" className={location.pathname === "/publisherList" ? "active" : ""}><img src={briefcaseIcon} alt='admin' /> Publishers</Link></li>)}

                    {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/freewheel" || location.pathname === "/pubmatic" || location.pathname === "/remoteFeedList" || location.pathname === "/campaignGam" || location.pathname === "/advertiser" || location.pathname === "/gamAutomation" ? "active" : ""}><img src={partnersIcon} alt='demand' /> Demand
                      <img src={HeaderArrow} className="hoverarrow" alt="" />
                      <div className="custom_drop_down_d2">
                        <ul className="">
                          <li className={location.pathname === "/advertiser" ? "active_menu_item_d2" : ""}><Link to="/advertiser" >Advertisers</Link></li>
                          <hr className="new_item_line_d2" />
                          <li className={location.pathname === "/remoteFeedList" ? "active_menu_item_d2" : ""}><Link to="/remoteFeedList" >Remote Feeds</Link></li>
                          <hr className="new_item_line_d2" />
                          <li className={location.pathname === "/freewheel" ? "active_menu_item_d2" : ""}><Link to="/freewheel">Freewheel</Link></li>
                          <li className={location.pathname === "/pubmatic" ? "active_menu_item_d2" : ""}><Link to="/pubmatic">Pubmatic</Link></li>
                          <li className={location.pathname === "/campaignGam" ? "active_menu_item_d2" : ""}><Link to="/campaignGam">GAM</Link></li>
                          <li className={location.pathname === "/gamAutomation" ? "active_menu_item_d2" : ""}><Link to="/gamAutomation">GAM Automation</Link></li>
                        </ul>
                      </div>
                    </Link></li>)}

                    <li><Link to="/adsTxt" className={location.pathname === "/adsTxt" ? "active" : ""}><img src={AdTxt} alt='AdsTxt' /> Ads.txt</Link></li>


                    {/* {(checkRole === "sa" || checkRole === "mobops") && (<li><Link to="/mediaPlanner" className={location.pathname === "/mediaPlanner" ? "active" : ""}><img src={reportIcon} alt='mediaPlanner' /> Media Planner</Link></li>)} */}

                    {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/domainsMediaPlanner" || location.pathname === "/ctvMediaPlanner" ? "active" : ""}><img src={reportIcon} alt='mediaPlanner' /> Media Planner
                      <img src={HeaderArrow} className="hoverarrow" alt="" />
                      <div className="custom_drop_down_d2">
                        <ul className="">
                          <li className={location.pathname === "/domainsMediaPlanner" ? "active_menu_item_d2" : ""}><Link to="/domainsMediaPlanner" >Domains</Link></li>
                          <li className={location.pathname === "/ctvMediaPlanner" ? "active_menu_item_d2" : ""}><Link to="/ctvMediaPlanner">CTV</Link></li>
                        </ul>
                      </div>
                    </Link></li>)}

                    {(checkRole === "sa" || checkRole === "mobops") && (<li><Link to="/reporting" className={location.pathname === "/reporting" ? "active" : ""}><img src={reportIcon2} alt='reporting' /> Reporting</Link></li>)}

                    {/* {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/reporting" || location.pathname === "/savedReports" ? "active" : ""}><img src={reportIcon2} alt='listManager' /> Report
                      <img src={HeaderArrow} className="hoverarrow" alt="" />
                      <div className="custom_drop_down_d2">
                        <ul className="">
                          <li className={location.pathname === "/savedReports" ? "active_menu_item_d2" : ""}><Link to="/savedReports" >Saved Reports</Link></li>
                          <li className={location.pathname === "/reporting" ? "active_menu_item_d2" : ""}><Link to="/reporting">Reporting</Link></li>
                        </ul>
                      </div>
                    </Link></li>)} */}

                    {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/appBundleListGam" || location.pathname === "/extendedUserListGam" || location.pathname === "/excludedCategoryListGam" || location.pathname === "/ipListGam" ? "active" : ""}><img src={listIcon} alt='listManager' /> List Manager
                      <img src={HeaderArrow} className="hoverarrow" alt="" />
                      <div className="custom_drop_down_d2">
                        <ul className="">
                          <li className={location.pathname === "/appBundleListGam" ? "active_menu_item_d2" : ""}><Link to="/appBundleListGam" >App Bundle List</Link></li>
                          <li className={location.pathname === "/excludedCategoryListGam" ? "active_menu_item_d2" : ""}><Link to="/excludedCategoryListGam">Excluded Category List</Link></li>
                          <li className={location.pathname === "/extendedUserListGam" ? "active_menu_item_d2" : ""}><Link to="/extendedUserListGam">Extended User List</Link></li>
                          <li className={location.pathname === "/ipListGam" ? "active_menu_item_d2" : ""}><Link to="/ipListGam">IP List</Link></li>
                        </ul>
                      </div>
                    </Link></li>)}

                    {(checkRole === "sa") && (
                      <li><Link className={location.pathname === "/userList" ? "active" : ""}><img src={adminIcon} alt='admin' /> Admin
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">
                            <li className={location.pathname === "/userList" ? "active_menu_item_d2" : ""}><Link to="/userList" >User List</Link></li>
                            {/* <li className={location.pathname === "/tagHistory" ? "active_menu_item_d2" : ""}><Link to="/tagHistory">Tagging History</Link></li>
                            <li className={location.pathname === "/domainHistory" ? "active_menu_item_d2" : ""}><Link to="/domainHistory">Domain History</Link></li> */}
                          </ul>
                        </div>
                      </Link></li>)}

                  </ul>
                </nav>
              </Col>
              <Col span={4} className='container_box--end p-0'>
                <div className="user_dropdown">
                  <div className='user_dropdown--symbol'>
                    <span>{name?.length > 0 ? name?.charAt(0)?.toUpperCase() : ""}</span>
                    <div className="user_dropdown--menu">
                      <div className="user_dropdown--menu-header">
                        <h4 className='heading'>{name.toUpperCase()}</h4>
                        <p className='text'>{email.toLowerCase()}</p>
                      </div>
                      <div className="user_dropdown--menu-body">
                        <Link className="menu_item" to="/profile"><img src={settingIcon} alt="USP" /> My Profile</Link>
                        {/* <Link className="menu_item"><img src={helpcircleIcon} alt="USP" /> Settings</Link> */}
                      </div>

                      <div className="user_dropdown--menu-footer">
                        <button className="menu_item" onClick={logout}><img src={logoutIcon} alt="USP" /> Logout</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </header>

      )}


    </>
  );
};

export default Header;
